import { useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { WORKSPACES, SIDEBARS, workspaceFromPath } from "@/lib/navRegistry";

// Reusable breadcrumbs derived from the current path + nav registry labels.
export function Breadcrumbs() {
  const { pathname } = useLocation();
  const wsId = workspaceFromPath(pathname);
  const ws = WORKSPACES.find((w) => w.id === wsId);
  const side = (SIDEBARS[wsId] || []).find((s) => s.route === pathname);

  const crumbs = [];
  if (ws) crumbs.push({ label: ws.label, to: ws.route });
  if (side && side.route !== ws?.route) crumbs.push({ label: side.label, to: side.route });
  if (crumbs.length === 0) return null;

  return (
    <nav className="mb-4 flex items-center gap-1.5 text-sm text-muted-foreground" data-testid="breadcrumbs">
      {crumbs.map((c, i) => (
        <span key={c.to} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5" />}
          {i < crumbs.length - 1 ? (
            <Link to={c.to} className="hover:text-foreground" data-testid={`crumb-${i}`}>{c.label}</Link>
          ) : (
            <span className="font-medium text-foreground">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
